<mat-sidenav-container class="docs-container">

  <mat-sidenav #docsSidenav [mode]="sidenavMode" [opened]="sidenavOpened" class="docs-sidenav">
    <app-docs-sidebar></app-docs-sidebar>
  </mat-sidenav>

  <mat-sidenav-content class="docs-content">
    @if (isMobile) {
      <button mat-icon-button class="docs-menu-toggle" (click)="toggleSidenav()" aria-label="Toggle documentation menu">
        <mat-icon>menu_open</mat-icon>
      </button>
    }
    <router-outlet></router-outlet>
  </mat-sidenav-content>

</mat-sidenav-container>
